const codes = [
    {code: '[jwt_auth] incorrect_password', message: "El password ingresado es inválido.", variant: "danger"},
    {code: '[jwt_auth] invalid_username', message: "El usuario no existe.", variant: "danger"},
];

const state = {
    variant: '',
    message: ''
};

const getters = {
    show(state) {
        return (state.variant !== '');
    }
};

const mutations = {
    SET_VARIANT(state, variant) {
        state.variant = variant;
    },
    SET_MESSAGE(state, message) {
        state.message = message
    }
};

const actions = {
    setAlert(context, code) {
        const resultCode = codes.find((codeItem) => {
            return codeItem.code === code;
        });

        if (resultCode) {
            context.commit('SET_VARIANT', resultCode.variant);
            context.commit('SET_MESSAGE', resultCode.message);
        }
    },
    clearAlert(context) {
        context.commit('SET_VARIANT', '');
        context.commit('SET_MESSAGE', '');
    }
};

export const alerts = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};